import { render, staticRenderFns } from "./ConfigureModelSetView.vue?vue&type=template&id=56e3f621&scoped=true&"
import script from "./ConfigureModelSetView.vue?vue&type=script&lang=js&"
export * from "./ConfigureModelSetView.vue?vue&type=script&lang=js&"
import style0 from "./ConfigureModelSetView.vue?vue&type=style&index=0&id=56e3f621&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e3f621",
  null
  
)

export default component.exports